// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1HQdO","description":"PatientConsentPreview_description__Tmxsj"};